import { IApiDataState } from "@/redux/store.types";

export const $LoadingModuleName = "loading";

export type TApiLoadingSlice = {};

export type TApiLoadingState = Partial<IRootApiLoadingState>;

type IRootApiLoadingState = {
    [key in keyof IApiDataState]: TApiLoadingSlice;
};
